module.exports = __webpack_public_path__ + "dd5bf8b6a30dc5467d0fbef72d36bf52.pdf";